/* RESPONSIBLE TEAM: team-knowledge-foundations */

const VALID_PROTOCOL_REGEX = /^(https?:\/\/|mailto:|tel:)/i;

export function hasValidProtocol(url: string): boolean {
  return VALID_PROTOCOL_REGEX.test(url.trim());
}

export function sanitizeUrl(url: string): string {
  if (hasValidProtocol(url)) {
    return url.replace(VALID_PROTOCOL_REGEX, (match) => match.toLowerCase());
  }
  return `https://${url.trim()}`;
}
